// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.request-container {
  display: grid;
  grid-template-columns: auto 1fr 20px;
  column-gap: 10px;
  padding: 10px;
  align-items: center;
  box-sizing: border-box;
  border-bottom: 1px solid #c1c1c1;
  font-size: 0.8em;
}

.request-image {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(3em + 10px);
  width: calc(3em + 10px);
  background-color: #d7d7d7;
  border-radius: 50%;
}
.request-image .selected-icon {
  position: absolute;
  right: 0;
  bottom: 0;
  border-radius: 50%;
  background-color: #26a69a;
  color: white;
  font-size: 1em;
  height: 1em;
  width: 1em;
}

.request-info {
  display: grid;
  row-gap: 1px;
}
.request-info .full-name {
  font-weight: bold;
}
.request-info .full-name-empty {
  font-style: italic;
  color: grey;
}

.arrow-icon {
  font-size: 1em;
  height: 1em;
  width: 1em;
}`, "",{"version":3,"sources":["webpack://./src/app/view/control/request-summary/request-summary.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,oCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,gCAAA;EACA,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;AACJ;AAAI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;AAER;;AAEA;EACI,aAAA;EACA,YAAA;AACJ;AAAI;EACI,iBAAA;AAER;AADQ;EACI,kBAAA;EACA,WAAA;AAGZ;;AAEA;EACI,cAAA;EACA,WAAA;EACA,UAAA;AACJ","sourcesContent":[".request-container {\n    display: grid;\n    grid-template-columns: auto 1fr 20px;\n    column-gap: 10px;\n    padding: 10px;\n    align-items: center;\n    box-sizing: border-box;\n    border-bottom: 1px solid #c1c1c1;\n    font-size: 0.8em;\n}\n\n.request-image {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: calc(3em + 10px);\n    width: calc(3em + 10px);\n    background-color: #d7d7d7;\n    border-radius: 50%;\n    & .selected-icon {\n        position: absolute;\n        right: 0;\n        bottom: 0;\n        border-radius: 50%;\n        background-color: #26a69a;\n        color: white;\n        font-size: 1em;\n        height: 1em;\n        width: 1em;\n    }\n}\n\n.request-info {\n    display: grid;\n    row-gap: 1px;\n    & .full-name {\n        font-weight: bold;\n        &-empty {\n            font-style: italic;\n            color: grey;\n        }\n    }\n}\n\n.arrow-icon {\n    font-size: 1em;\n    height: 1em;\n    width: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
